import React, { PureComponent } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  TablePagination,
  IconButton,
  TextField,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FilterListIcon from "@mui/icons-material/FilterList";
import { CSVLink } from "react-csv";
import { withApiContext, withUserContext, withLabelsContext } from "context";

class TraineeProgressTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      trainees: [],
      page: 0,
      rowsPerPage: 10,
      loading: true,
      // filterStatus: "",
      filteredTrainees: [],
      showFilters:false,
      searchText: "",
      orderBy: "",        
      order: "asc",
      activeFilter: "",
      filterStatus: "all",
      // completion %
      progressFrom: "",
      progressTo: "",
      // score
      scoreFrom: "",
      scoreTo: "", 
      downloadData:[],
      
    };
    this.csvLink = React.createRef();
  }

  getCSVheaders = () => [
  { label: "Student Name", key: "student_name" },
  { label: "Registration No", key: "registration_no" },
  { label: "Status", key: "status" },
  { label: "Progress %", key: "progress_percent" },
  { label: "Minutes Viewed", key: "minutes_viewed" },
  { label: "Pages Viewed", key: "pages_viewed" },
  { label: "PLE Score", key: "ple_score" },
];

prepareDownloadData = () => {
  const data = this.state.filteredTrainees.map((row) => ({
    ...row,
    status: this.getStatusLabel(row.status),
  }));

  this.setState({ downloadData: data }, () => {
    this.csvLink.current.link.click();
  });
};


  componentDidMount() {
    console.log(this.props)
    this.getCourseProgressStudent();
  }

  getCourseProgressStudent = (chapterId) => {
    const { entity, ctx_user } = this.props;

    let args = {
      chapterId: "0",
      classId: this.props.data.class_id,
      academicYearId: this.props.ctx_user.user.acadYearId,
      curriculumId: this.props.data.curriculum_id,
      coursePublishId: this.props.data.course_publish_id,
      courseId:
        this.props.data.course_id,
    };

    this.props.ctx_api
      .privateRequestRow({
        cmd: "get_trainer_course_progress_student",
        args: args,
      })
      .then(this.handleGetCourseProgressStudentResponse)
      .catch(this.handleGetCourseProgressStudentFailure);
  };

  handleGetCourseProgressStudentResponse = (res) => {
    console.log(res.rsp.student_details)
    if (res?.rsp?.student_details && Array.isArray(res.rsp.student_details)) {
      this.setState({ 
        trainees: res.rsp.student_details, 
        filteredTrainees: res.rsp.student_details,
        loading: false 
      });
    } else {
      console.warn("Unexpected response format:", res);
      this.setState({ loading: false });
    }
  };

  applyFilters = () => {
  const {
    searchText,
    trainees,
    filterStatus,
    progressFrom,
    progressTo,
    scoreFrom,
    scoreTo,
  } = this.state;

  let data = [...trainees];

   if (searchText.trim() !== "") {
    const search = searchText.toLowerCase();
    data = data.filter(
      (t) =>
        t.student_name?.toLowerCase().includes(search) ||
        t.registration_no?.toLowerCase().includes(search)
    );
  }

  // Status filter
  if (filterStatus && filterStatus !== "all") {
    data = data.filter(
      (t) => t.status?.toString() === filterStatus
    );
  }

  // Completion %
  if (progressFrom !== "" && !isNaN(progressFrom)) {
    data = data.filter(
      (t) => Number(t.progress_percent) >= Number(progressFrom)
    );
  }

  if (progressTo !== "" && !isNaN(progressTo)) {
    data = data.filter(
      (t) => Number(t.progress_percent) <= Number(progressTo)
    );
  }

  // Score
  if (scoreFrom !== "" && !isNaN(scoreFrom)) {
    data = data.filter(
      (t) => Number(t.ple_score) >= Number(scoreFrom)
    );
  }

  if (scoreTo !== "" && !isNaN(scoreTo)) {
    data = data.filter(
      (t) => Number(t.ple_score) <= Number(scoreTo)
    );
  }

  this.setState({ filteredTrainees: data });
};


handleFilterChange = (event) => {
  const { name, value } = event.target;

this.setState((prevState) => {
    const newState = { [name]: value, page: 0 };

    if (name === "activeFilter") {
      if (value === "status") {
        newState.progressFrom = "";
        newState.progressTo = "";
        newState.scoreFrom = "";
        newState.scoreTo = "";
      } else if (value === "completion") {
        newState.filterStatus = "all";
        newState.scoreFrom = "";
        newState.scoreTo = "";
      } 
      // else if (value === "scoreRange") {
      //   newState.filterStatus = "all";
      //   newState.progressFrom = "";
      //   newState.progressTo = "";
      // }
    }

    return newState;
  }, this.applyFilters);
};

resetFilters = () => {
  this.setState(
    {
      searchText: "",
      activeFilter: "",     
      filterStatus: "all",    
      progressFrom: "",       
      progressTo: "",
      scoreFrom: "",          
      scoreTo: "",
      page: 0,
    },
    this.applyFilters       
  );
};



  handleGetCourseProgressStudentFailure = (err) => {
    console.error("Failed to fetch trainee progress:", err);
    this.setState({ loading: false });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  handleSort = (column) => {
  const { orderBy, order, filteredTrainees } = this.state;

  const isAsc = orderBy === column && order === "asc";
  const newOrder = isAsc ? "desc" : "asc";

  const sortedData = [...filteredTrainees].sort((a, b) => {
    const valA = a[column] ?? "";
    const valB = b[column] ?? "";

    // String sort (Name)
    if (typeof valA === "string") {
      return newOrder === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    }

    // Number sort (Progress %, PLE)
    return newOrder === "asc" ? valA - valB : valB - valA;
  });

  this.setState({
    orderBy: column,
    order: newOrder,
    filteredTrainees: sortedData,
    page: 0,
  });
};


  getStatusColor = (status) => {
    // Map numeric status to meaningful labels
    const statusMap = {
      1: "Yet to Start",
      2: "In Progress", 
      3: "Completed",
      // 4: "Not Started"
    };
    
    const statusLabel = statusMap[status] || "Unknown";
    
    switch (statusLabel) {
      case "Completed":
        return { bg: "#4A148C", color: "#fff" };
      case "In Progress":
        return { bg: "#7E57C2", color: "#fff" };
      case "Yet to Start":
        return { bg: "#B39DDB", color: "#fff" };
      // case "Not Started":
      //   return { bg: "#E1BEE7", color: "#333" };
      default:
        return { bg: "#ccc", color: "#000" };
    }
  };

  getStatusLabel = (status) => {
    const statusMap = {
      1: "Yet to Start",
      2: "In Progress", 
      3: "Completed",
      // 4: "Not Started"
    };
    
    return statusMap[status] || "Unknown";
  };

  render() {
    const { trainees, page, rowsPerPage, loading } = this.state;

    return (
      <Box>
        {/* Header */}
        {/* Header */}
<Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  mb={2}
>
  <span>
    <strong>Total Trainees:</strong> {this.state.trainees.length} |{" "}
    <strong>Showing:</strong> {this.state.filteredTrainees.length}
  </span>

  <Box display="flex" gap={1}>
  <TextField
  size="small"
  placeholder="Search Name / Reg ID"
  sx={{ minWidth: 220 }}
  value={this.state.searchText}
  onChange={(e) =>
    this.setState(
      { searchText: e.target.value, page: 0 },
      this.applyFilters
    )
  }
  />
{this.state.showFilters && (
  <>
     <TextField
       select
       name="activeFilter"
       SelectProps={{ native: true }}
       size="small"
       sx={{ minWidth: 160 }}
       value={this.state.activeFilter}
       onChange={(e) => {
       if (e.target.value === "ResetFilter") {
          this.resetFilters();
       } else {
          this.handleFilterChange(e);
       } 
  }}
>
  <option value="" disabled>Filter By</option>
  <option value="status">Status</option>
  <option value="completion">Completion %</option>
  {/* <option value="scoreRange">Score Range</option> */}
  <option value="ResetFilter">Reset Filter</option>
</TextField>
{this.state.activeFilter === "status" && (
  <TextField
    select
    name="filterStatus"
    SelectProps={{ native: true }}
    size="small"
    sx={{ minWidth: 160 }}
    value={this.state.filterStatus}
    onChange={this.handleFilterChange}
  >
    <option value="" disabled>Status</option>
    <option value="all">All</option>
    <option value="1">Yet To Start</option>
    <option value="2">In Progress</option>
    <option value="3">Completed</option>
  </TextField>
)}

{this.state.activeFilter === "completion" && (
  <TextField
    select
    name="completionRange"
    SelectProps={{ native: true }}
    size="small"
    sx={{ minWidth: 180 }}
    onChange={(e) => {
      const [min, max] = e.target.value.split("-");
      this.setState({
        progressFrom: min || 0,
        progressTo: max || "",
      }, this.applyFilters);
    }}
  >
    <option value="" disabled>Completion %</option>
    <option value="0-24">0 - 24%</option>
    <option value="25-50">25 - 50%</option>
    <option value="51-75">51 - 75%</option>
    <option value="76-100">76 - 100%</option>
  </TextField>
)}
  </>
)}
{/* {this.state.activeFilter === "scoreRange" && (
  <TextField
    select
    name="scoreRange"
    SelectProps={{ native: true }}
    size="small"
    sx={{ minWidth: 180 }}
    onChange={(e) => {
      const [min, max] = e.target.value.split("-");
      this.setState({
        scoreFrom: min,
        scoreTo: max || "",
      }, this.applyFilters);
    }}
  >
    <option value="" disabled>Score Range</option>
    <option value="1-50">1 - 50</option>
    <option value="51-100">51 - 100</option>
    <option value="101-150">101 - 150</option>
    <option value="151-200">151 - 200</option>
    <option value="200-">200 & Above</option>
  </TextField>
)} */}

  <IconButton
   color="primary"
   onClick={() =>
    this.setState((prev) => ({ showFilters: !prev.showFilters })) }>
      <FilterListIcon />
  </IconButton>

    <IconButton color="primary" onClick={this.prepareDownloadData}>
      <DownloadIcon />
    </IconButton>
    <CSVLink
     headers={this.getCSVheaders()}
     filename="Trainee_Progress_Report.csv"
     data={this.state.downloadData}
     ref={this.csvLink}
    />
  </Box>
</Box>


        {/* Summary */}
        {/* <Box mb={2} p={2} sx={{ backgroundColor: "#f8f9fa", borderRadius: 1 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>
              <strong>Total Trainees:</strong> {this.state.trainees.length} | 
              <strong> Showing:</strong> {this.state.filteredTrainees.length}
            </span>
            {this.state.filterStatus && (
              <span style={{ color: "#666", fontSize: "14px" }}>
                Filtered by: {this.getStatusLabel(this.state.filterStatus)}
              </span>
            )}
          </div>
        </Box> */}

        {/* Table */}
        <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
          {loading ? (
            <Box p={3} textAlign="center">
              <div style={{ color: "#666" }}>Loading trainee progress...</div>
            </Box>
          ) : this.state.filteredTrainees.length === 0 ? (
            <Box p={3} textAlign="center">
              <div style={{ color: "#666" }}>
                {this.state.trainees.length === 0 
                  ? "No trainee data available for this course." 
                  : "No trainees match the selected filter."}
              </div>
            </Box>
          ) : (
            <>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#4A148C" }}>
                   <TableCell sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer" }}
                      onClick={() => this.handleSort("student_name")}
                     >
                     Student
                     {this.state.orderBy === "student_name" &&
                     (this.state.order === "asc" ? " ▲" : " ▼")}
                    </TableCell>

                    <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Status
                    </TableCell>

                    <TableCell
                      sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer", textAlign: "center" }}
                      onClick={() => this.handleSort("progress_percent")}
                     >
                     Progress %
                     {this.state.orderBy === "progress_percent" &&
                     (this.state.order === "asc" ? " ▲" : " ▼")}
                     </TableCell>

                     <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                      Minutes Viewed
                     </TableCell>

                     <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                      Pages Viewed
                      </TableCell>

                      <TableCell
                       sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer", textAlign: "center" }}
                       onClick={() => this.handleSort("ple_score")}
                       >
                       PLE Score
                       {this.state.orderBy === "ple_score" &&
                       (this.state.order === "asc" ? " ▲" : " ▼")}
                      </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.filteredTrainees
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <TableRow
                        key={idx}
                        sx={{
                          backgroundColor:
                            idx % 2 === 0 ? "#f8f5ff" : "#ffffff",
                          "&:hover": {
                            backgroundColor: "#ede7f6",
                            cursor: "pointer",
                          },
                        }}
                      >
                        <TableCell>
                          <div>
                            <div style={{ fontWeight: "400",fontSize:13 }}>{row.student_name}</div>
                            <div style={{ fontSize: "12px", color: "#666" }}>Reg: {row.registration_no}</div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={this.getStatusLabel(row.status)}
                            sx={{
                              backgroundColor:
                                this.getStatusColor(row.status).bg,
                              color: this.getStatusColor(row.status).color,
                              fontWeight: "bold",
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <div style={{ textAlign: "center" }}>
                            <div style={{ fontWeight: "400",fontSize:13  }}>{row.progress_percent}%</div>
                          </div>
                        </TableCell>
                        <TableCell>{row.minutes_viewed}</TableCell>
                        <TableCell>{row.pages_viewed}</TableCell>
                        <TableCell>
                          <div style={{ textAlign: "center" }}>
                            <div style={{ fontWeight: "400",fontSize:13  }}>{row.ple_score}</div>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={this.state.filteredTrainees.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </>
          )}
        </TableContainer>
      </Box>
    );
  }
}

export default withApiContext(withUserContext(withLabelsContext(TraineeProgressTable)));
